// COMMON

export const API_HOST = process.env.REACT_APP_API_HOST;
export const WEB_REP_HOST = process.env.WEB_REPORT_HOST;
export const REQUEST_API = 'REQUEST_API';
export const RECEIVE_FROM_API = 'RECEIVE_FROM_API';
export const RECEIVE_FROM_API_HOLDING_DATA = 'RECEIVE_FROM_API_HOLDING_DATA';
export const RECEIVE_INFOGRAPHICS_FROM_API = 'RECEIVE_INFOGRAPHICS_FROM_API';
export const REQUEST_API_FAILURE = 'REQUEST_API_FAILURE';
export const REQUEST_API_FAILURE_HOLDING_DATA =
  'REQUEST_API_FAILURE_HOLDING_DATA';
export const REQUEST_API_HOLDING_DATA = 'REQUEST_API_HOLDING_DATA';

export const MULTI_NARRATIVE_VERSIONS = 'MULTI_NARRATIVE_VERSIONS';

export const REQUEST_POST_ACR_INFO_BOX_SUCCESS =
  'REQUEST_POST_ACR_INFO_BOX_SUCCESS';

// Singals
export const UPDATE = 'UPDATE';
export const SUCCESS_REQUEST = 'SUCCESS_REQUEST';

export const ICON_KWARGS = {
  height: '.8em',
  fill: 'white',
  color: 'white',
  style: { marginLeft: '.5em' },
};

export const DATE_FORMAT = 'YYYY-MM-DD';
export const NEW_DATE_FORMAT = 'yyyy-MM-dd';
export const CALENDAR_FULL_DATE_FORMAT = 'd-MMM-yyyy';
export const CALENDAR_DATE_FORMAT = 'dd/MM/yyyy';

export const fileNameMap = {
  acr_1: 'ACR1',
  acr_5: 'ACR5',
};

export const publicationUploadMaxSize = 25;

export const maxCommentTitleCharacters = 150;

export const commentsErrorsMessages = {
  title: {
    empty: 'Please fill out the comment title field',
    maxLength: `Comment title can't exceed ${maxCommentTitleCharacters} characters`,
  },
  content: {
    empty: 'Please fill out the comment message field',
  },
};

export const CRF23 = 'CRF 2022-2025';

export const wordCountAllowedSections = [
  'Programme performance',
  'Cross-cutting Results',
];

export const narrativeAutosaveInterval = 30000;

export const rolesToLabels = {
  co_approver: 'Co Approver',
  co_coordinator: 'Co Coordinator',
  coordinator: 'Coordinator',
  editor: 'Editor',
  hq_admin: 'HQ Admin',
  hq_reviewer: 'HQ Reviewer',
  rd_approver: 'RD Approver',
  viewer: 'Viewer',
};

export const TRANSITION_LABELS = {
  send_to_review: 'Send to Review',
  send_to_cd_approval: 'Send to CD Approval',
  send_to_cd_approved: 'Approve',
  send_to_rd_approval: 'Send to RD Approval',
  send_to_rd_approved: 'Approve',
  publish: 'Publish',
  back_to_initial_draft: 'Back to Initial Draft',
  back_to_review: 'Back to Review',
  back_to_cd_approval: 'Back to CD Approval',
  back_to_cd_approved: 'Back to CD Approved',
  back_to_rd_approval: 'Back to RD Approval',
  back_to_rd_approved: 'Back to RD Approved',
};

export const TRANSITION_AIM = {
  send_to_review: 'review',
  send_to_cd_approval: 'cd_approval',
  send_to_cd_approved: 'cd_approved',
  send_to_rd_approval: 'rd_approval',
  send_to_rd_approved: 'rd_approved',
  publish: 'published',
  back_to_initial_draft: 'initial_draft',
  back_to_review: 'review',
  back_to_cd_approval: 'cd_approval',
  back_to_cd_approved: 'cd_approved',
  back_to_rd_approval: 'rd_approval',
  back_to_rd_approved: 'rd_approved',
};

export const forward = 'forward';
export const backward = 'backward';
export const TRANSITION_DIRECTION = {
  send_to_review: forward,
  send_to_cd_approval: forward,
  send_to_cd_approved: forward,
  send_to_rd_approval: forward,
  send_to_rd_approved: forward,
  publish: forward,
  back_to_initial_draft: backward,
  back_to_review: backward,
  back_to_cd_approval: backward,
  back_to_cd_approved: backward,
  back_to_rd_approval: backward,
  back_to_rd_approved: backward,
};

export const CURRENT_STATE_LABELS = {
  new: 'New',
  initial_draft: 'Initial Draft',
  review: 'Review',
  cd_approval: 'CD Approval',
  cd_approved: 'CD Approved',
  rd_approval: 'RD Approval',
  rd_approved: 'RD Approved',
  published: 'Published',
};

export const STATUS_COLORS = {
  new: { background: '#FFF3CD', color: '#664D03' },
  'Initial Draft': { background: '#EFF2F5', color: '#051D21' },
  Review: { background: '#CCE5FF', color: '#003351' },
  'CD Approval': { background: '#FFE5CC', color: '#663300' },
  'CD Approved': { background: '#D4EDDA', color: '#155724' },
  'RD Approval': { background: '#E5CCFF', color: '#3D0066' },
  'RD Approved': { background: '#D1ECF1', color: '#0C5460' },
  Published: { background: '#C4FFCB', color: '#003917' },
};

export const REVIEW_BUTTONS = {
  set_review_status: 'Set review status',
  technical_review: 'Technical review',
};

export const DATA_STATUS_CHECK_LINK =
  'https://analytics.wfp.org/#/views/ACRdatareadinesstool/COACROverview?:iid=1?:showAppBanner=false&:display_count=n&:showVizHome=n&:origin=viz_share_link%3FiframeSizedToWindow&%3Aembed=y&%3AshowAppBanner=false&%3Adisplay_count=no&%3AshowVizHome=no&%3Atoolbar=yes#1';
